import { Image } from "@/types/image";

const NEXT_PUBLIC_UPLOADS_URL = process.env.NEXT_PUBLIC_UPLOADS_URL || '';

export function getBaseUrl(basePath: string = '/uploads/'): string {
  const baseUrl = NEXT_PUBLIC_UPLOADS_URL?.replace(/\/$/, '') ||
    (typeof window !== 'undefined' ? window.location.origin : '');

  // убираем слэш в начале/конце basePath
  const cleanBasePath = basePath.replace(/^\/|\/$/g, '');

  // если baseUrl уже оканчивается на cleanBasePath — не добавляем
  if (baseUrl.endsWith(cleanBasePath)) {
    return baseUrl;
  }

  return `${baseUrl}/${cleanBasePath}`;
}


export const getUploadsUrl = (): string => {
  return getBaseUrl();
}

export async function urlToFile(url: string, filename: string, mimeType = "image/jpeg"): Promise<File> {
  const response = await fetch(url);
  const blob = await response.blob();
  return new File([blob], filename, { type: mimeType });
}

export async function imageUrlsToFiles(urls: string[]): Promise<File[]> {
  const baseUrl = getBaseUrl() + "/";
  return Promise.all(
    urls.map(url =>
      urlToFile(
        NEXT_PUBLIC_UPLOADS_URL ? `${baseUrl}${url}` : `${baseUrl}${url}`,
        url.split('/').pop() || 'image.jpg'
      )
    )
  );
}

export async function videoUrlsToFiles(urls: string[]): Promise<File[]> {
  const baseUrl = getBaseUrl() + "/";
  return Promise.all(
    urls.map(url =>
      urlToFile(
        NEXT_PUBLIC_UPLOADS_URL ? `${baseUrl}${url}` : `${baseUrl}${url}`,
        url.split('/').pop() || 'video.mp4',
        'video/mp4'
      )
    )
  );
}

type WithImages = { images?: Image[] };

export function getPlaceholderImageSrc(placeholder: string = "/placeholder.webp") {
  return placeholder;
}

export function getImageSrc(
  item: WithImages | null | undefined,
  type: string = "main",
  basePath: string = "/uploads/",
  placeholder: string = "/placeholder.webp"
) {
  const baseUrl = getBaseUrl(basePath) + "/";
  const image = item?.images?.find(e => e.type === type && e.path);
  return image?.path ? `${baseUrl}${image.path}` : placeholder;
}

export function getImagesByType(
  item: WithImages | null | undefined,
  type: string = "gallery",
  basePath: string = "/uploads/",
  placeholder: string = "/placeholder.webp"
): string[] {
  const baseUrl = getBaseUrl(basePath) + "/";
  const images =
    item?.images
      ?.filter(img => img.type === type && img.path)
      .map(img => `${baseUrl}${img.path}`) || [];

  return images.length ? images : [placeholder];
}